<template>
    <div>

        <pre v-if="false"> <!-- Debug in development purpose -->
            {{ JSON.stringify(value, null, 4)}}
        </pre>

        <component v-for="(layout, i) in value" :key="i" :layout="layout" :is="layout.is"/>

    </div>
</template>

<script>
export default {
    props: {
        value: { type: Array, required: true },
    }
}
</script>
